<template>
  <button
    type="button"
    class="inline-flex w-full justify-center rounded-sm border bg-white px-[18px] py-2.5 text-base font-semibold shadow-sm focus:outline-brand-800 sm:w-auto sm:text-sm disabled:opacity-50 disabled:pointer-events-none"
    :class="
      danger
        ? 'border-red-500 text-red-500 hover:text-red-400'
        : 'border-gray-300 text-gray-700 hover:text-gray-500'
    "
    @click="click"
    :disabled="props.disabled"
  >
    <slot>
      <component
        :is="props.icon"
        class="-ml-1 mr-2 h-5 w-5"
        aria-hidden="true"
        v-if="props.icon"
      />
      {{ props.label }}
    </slot>
  </button>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";

const props = defineProps({
  label: String,
  icon: Object,
  disabled: { type: Boolean, default: false },
  danger: Boolean,
});

const emit = defineEmits(["click"]);
const click = () => emit("click");
</script>
